import { Action } from 'redux';
import _ from 'underscore';

import {
  isAddToContentSelectionAction,
  isDeselectAllAction,
  isRemoveFromContentSelectionAction,
} from '../../actions/ContentExplorerSelectionActions';
import { isEnterSpaceAction } from '../../actions/EnterSpaceAction';
import { getKeyForExplorableItem } from '../../models/ContentType';
import { IExplorableItemTypeInfo } from '../../models/resourceInfoParts';
import { ItemsSet, makeItemsSet } from '../../utils/ItemsSet';

export function selectedItemsReducer(
  previousState: ItemsSet<IExplorableItemTypeInfo> = { },
  action: Action = null
): ItemsSet<IExplorableItemTypeInfo> {
  if (isAddToContentSelectionAction(action)) {
    const prunedItemSet = pruneToIExplorableItemTypeInfo(action.itemsSet);
    return {
      ...previousState,
      ...prunedItemSet
    };
  } else if (isRemoveFromContentSelectionAction(action)) {
    const keysToRemove: string[] = _.keys(action.itemsSet);
    return _.omit(previousState, keysToRemove);
  } else if (isDeselectAllAction(action) || isEnterSpaceAction(action)) {
    if (!_.isEmpty(previousState)) {
      return { };
    }
  }

  return previousState;
}

function pruneToIExplorableItemTypeInfo(itemsSet: ItemsSet<IExplorableItemTypeInfo>): ItemsSet<IExplorableItemTypeInfo>{
  const prunedItems: IExplorableItemTypeInfo[] = [];

  for(let key in itemsSet){
    const original: IExplorableItemTypeInfo = itemsSet[key];
    const pruned: IExplorableItemTypeInfo = {
      contentType: original.contentType,
      id: original.id
    };
    prunedItems.push(pruned);
  }

  return makeItemsSet(i => getKeyForExplorableItem(i), ...prunedItems);
}
